/*
 * loadingReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Chiara Amato
 * @since 16-Jun-2022
 */

import produce from 'immer'
import { actionTypes } from '../actions/loading'

const ACTION_HANDLERS = {
  [actionTypes.DO_GLOBAL_LOADING]: produce((draft, action) => {
    draft.global = action.payload
  }),
  [actionTypes.DO_LOCAL_LOADING]: produce((draft, action) => {
    if (action.payload.id) { // doLocalLoading({ id: 'MyId', value: true/false })
      draft[`local_${action.payload.id}`] = action.payload.value
    } else {
      draft.local = action.payload
    }
  })
  // @generator reducer:type:action

}

// The initial state of the loading
const initialState = {
  global: false,
  local: false
}

const loading = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default loading
